import { addDays, startOfDay, startOfMonth, startOfWeek, type WeekStart } from '@awwyeah/shared';

/**
 * Which day a new event should be pre-filled with when the add button is pressed.
 *
 * Usability testing 2026-08-01: the add button has to mean "add something *here*". The
 * selected day wins whenever it is actually on screen; otherwise today (if the period on
 * screen contains it) and finally the first day of the period being viewed — never a date
 * the user isn't looking at.
 */
export type CalendarViewMode = 'month' | 'week' | 'day';

export function addTargetDay(options: {
  view: CalendarViewMode;
  cursor: Date;
  selectedDay: Date;
  today: Date;
  weekStartsOn: WeekStart;
}): Date {
  const { view, cursor, selectedDay, today, weekStartsOn } = options;
  if (view === 'day') return startOfDay(selectedDay);

  const [from, to] =
    view === 'week'
      ? [startOfWeek(cursor, weekStartsOn), addDays(startOfWeek(cursor, weekStartsOn), 6)]
      : [startOfMonth(cursor), new Date(cursor.getFullYear(), cursor.getMonth() + 1, 0)];

  const within = (day: Date): boolean => {
    const time = startOfDay(day).getTime();
    return time >= startOfDay(from).getTime() && time <= startOfDay(to).getTime();
  };

  if (within(selectedDay)) return startOfDay(selectedDay);
  if (within(today)) return startOfDay(today);
  return startOfDay(from);
}
